import { render, staticRenderFns } from "./pi-my-account-tabs.vue?vue&type=template&id=6ab8ec00&scoped=true&"
import script from "./pi-my-account-tabs.vue?vue&type=script&lang=js&"
export * from "./pi-my-account-tabs.vue?vue&type=script&lang=js&"
import style0 from "./pi-my-account-tabs.vue?vue&type=style&index=0&id=6ab8ec00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab8ec00",
  null
  
)

export default component.exports